import { createAction, props } from '@ngrx/store';
import { Availability } from '../../models/availability';
import { ServerMessage } from '../../models/server-message';

export const pickupReset = createAction(
    '[Pickup] Reset State'
);

export const pickupSelectCourier = createAction(
    '[Pickup] Select Courier',
    props<{ courierModule: string }>()
);

export const pickupSelectShipments = createAction(
    '[Pickup] Select Shipments',
    props<{ shipmentSelection: string[] }>()
);

export const pickupSetAvailability = createAction(
    '[Pickup] Availability Data Received',
    props<{ availability: Availability[] }>()
);

export const pickupSelectDate = createAction(
    '[Pickup] Set Date',
    props<{ date: string }>()
);

export const pickupSelectReadyTime = createAction(
    '[Pickup] Set Ready Time',
    props<{ readyTime: string }>()
);

export const pickupSelectCloseTime = createAction(
    '[Pickup] Set Close Time',
    props<{ closeTime: string }>()
);

export const pickupSetParameter = createAction(
    '[Pickup] Set Parameter',
    props<{ name: string, value: string }>()
);

export const pickupSubmitRequest = createAction(
    '[Pickup] Submit Pickup Request'
);

export const pickupSubmitSuccess = createAction(
    '[Pickup] Submission Succeeded'
);

export const pickupSubmitFailure = createAction(
    '[Pickup] Submission Failed',
    props<{ messages: ServerMessage[] }>()
);

export const pickupSetSelection = createAction(
    '[Pickup] Set selected Pickups',
    props<{ selection: string[] }>()
);

export const pickupCancelRequest = createAction(
    '[Pickup] Cancel Pickup Request'
);

export const pickupCancelSuccess = createAction(
    '[Pickup] Cancel Pickup Success'
);

export const pickupCancelFailure = createAction(
    '[Pickup] Cancel Failed',
    props<{ messages: ServerMessage[] }>()
);



export const pickupStartForShipment = createAction(
    '[Shipment] Start Pickup for Shipment',
    props<{ shipmentId: string }>()
);
